var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9375 9.14375H10.2463L10.0013 8.91931C10.8588 7.97169 11.375 6.74144 11.375 5.40313C11.375 2.41894 8.82875 0 5.6875 0C2.54625 0 0 2.41894 0 5.40313C0 8.38731 2.54625 10.8063 5.6875 10.8063C7.09625 10.8063 8.39125 10.3158 9.38875 9.50119L9.625 9.73394V10.3906L14 14.5386L15.3038 13.3L10.9375 9.14375ZM5.6875 9.14375C3.50875 9.14375 1.75 7.47294 1.75 5.40313C1.75 3.33331 3.50875 1.6625 5.6875 1.6625C7.86625 1.6625 9.625 3.33331 9.625 5.40313C9.625 7.47294 7.86625 9.14375 5.6875 9.14375Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchicon);
export default __webpack_public_path__ + "static/media/Searchicon.af5faa411592ec1ba09efebaf5ab7572.svg";
export { ForwardRef as ReactComponent };